import { Box, IconButton, Tooltip } from "@mui/joy";
import { useAuth } from "../../contexts/api";
import { useAlert } from "../../contexts/app/notificationToast";
import { accountBoxRootSx, accountBoxUsernameTypographySx } from "../../styles/globalStyles";
import { SLogout } from "../../styles/StyledMUI";
import DarkTypography from "./DarkTypography";
import { userDisplayName } from "../../utils/userHelper";

export default function AccountBox() {
  const { user, logoutCallback } = useAuth();
  const { showAlert } = useAlert();

  const handleLogout = async () => {
    try {
      await logoutCallback();
      showAlert("A bientôt !", "success");
    } catch (err) {
      if (err instanceof Error) {
        showAlert(err.message, "danger");
      }
    }
  };

  return (
    <Box sx={accountBoxRootSx}>
      <DarkTypography level="body-md" colorVariant="primary" sx={accountBoxUsernameTypographySx}>
        {userDisplayName(user) || "Utilisateur"}
      </DarkTypography>

      <Tooltip title="Déconnexion" arrow>
        <IconButton onClick={handleLogout} size="sm" variant="plain">
          <SLogout />
        </IconButton>
      </Tooltip>
    </Box>
  );
}
